import { useEffect, useState } from 'react'
import { useColorMutations } from '../../hooks/useColorMutations'

export const useNewColorForm = (
  variantId: number,
  onNewColorChange: (variantId: number, hasChanges: boolean) => void
) => {
  const [color, setColor] = useState('')
  const [imageUrls, setImageUrls] = useState<string>('')

  const { createColorWithImages, isCreating } = useColorMutations({
    variantId,
    onSuccess: () => {
      // Clear form after successful save
      setColor('')
      setImageUrls('')
    },
  })

  useEffect(() => {
    const hasNewColorChanges = !!(color.trim() || imageUrls.trim())
    onNewColorChange(variantId, hasNewColorChanges)
  }, [color, imageUrls, variantId, onNewColorChange])

  const handleSaveNewColor = async () => {
    if (!color.trim() || !imageUrls.trim()) {
      return
    }
    await createColorWithImages(color, imageUrls)
  }

  return {
    color,
    setColor,
    imageUrls,
    setImageUrls,
    handleSaveNewColor,
    isSaving: isCreating,
  }
}

